import {TFunction} from 'i18next';
import {FORM_NAMES} from './constants';
import {GROUP_TYPES, SeasonRule} from '@chekin/core';

export type SeasonRules = {
  lessThanRule?: SeasonRule | null;
  betweenRule?: SeasonRule | null;
  moreThanRule?: SeasonRule | null;
};

export const NO_SEASON_RULES: SeasonRules = {
  lessThanRule: null,
  betweenRule: null,
  moreThanRule: null,
};

type GetLabelsProps = {
  visibleFields: Record<FORM_NAMES, boolean>;
  betweenRule?: SeasonRule | null;
  lessThanRule?: SeasonRule | null;
  moreThanRule?: SeasonRule | null;
};
function getLabels({
  moreThanRule,
  betweenRule,
  lessThanRule,
  visibleFields,
  t,
}: GetLabelsProps & {t: TFunction}) {
  const labels = {} as Record<FORM_NAMES, string>;
  const isAdultTheOldestGroup =
    visibleFields.junior && visibleFields.middle && !visibleFields.senior;

  labels[FORM_NAMES.junior] = t('under_age_years_old', {
    age: lessThanRule?.less_than ?? betweenRule?.up_to ?? moreThanRule?.up_to,
  });
  labels[FORM_NAMES.middle] = isAdultTheOldestGroup
    ? t('seniors_counter_label', {
        age: (lessThanRule?.less_than ?? 0) + 1,
      })
    : t('from_to_years_old', {
        from: betweenRule?.up_to ?? lessThanRule?.less_than,
        to: betweenRule?.less_than ?? moreThanRule?.up_to,
      });
  labels[FORM_NAMES.senior] = t('seniors_counter_label', {
    age: moreThanRule?.up_to ?? betweenRule?.less_than ?? lessThanRule?.less_than,
  });

  return labels;
}

const getReservationTypeOptions = (t: TFunction) => {
  return [
    {label: t('family'), value: GROUP_TYPES.family},
    {label: t('group'), value: GROUP_TYPES.group},
    {label: t('tourist_group'), value: GROUP_TYPES.tourist},
  ];
};

export {getLabels, getReservationTypeOptions};
